
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from "react-toastify";
import { saveCreateUser, updateCreateUser } from '../../../../services/CommonService';

function AddCreateUser({ updateprop }) {
    const [filefields, setFileFields] = useState(null);
    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const fields = {
        position:'',
        name: '',
        email: '',
        password: ''


    }

    const errors = {
        position:'',
        name: '',
        email: '',
        password: ''

    }

    const [errorFields, setErrorFields] = useState(errors);
    const [formfields, setFromFields] = useState(fields);


    useEffect(() => {

        setFieldData();


    }, []);

    const { name, email, password, tenant,position } = formfields;

    const setFieldData = async () => {
        if (updateprop?.id) {
            setFromFields(updateprop);

        }
    }

    const validateForm = async () => {
        let fields = formfields;
        let errors = {};
        let formIsValid = true;



        if (!fields["name"]) {
            formIsValid = false;
            errors["name"] = "*Please enter name .";
        }
        if (!fields["position"]) {
            formIsValid = false;
            errors["position"] = "*Please enter position .";
        }
        if (!fields["email"]) {
            formIsValid = false;
            errors["email"] = "*Please enter email .";
        }
        if (!fields["password"]) {
            formIsValid = false;
            errors["password"] = "*Please enter password .";
        }

        setErrorFields(errors)
        return formIsValid;

    }

    const submitForm = async () => {
        console.log(formfields);
        const isValid = await validateForm();
        if (isValid) {

            if (!formfields.id) {
                //save
                const Response = await saveCreateUser(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("user saved successfully");
                    formfields.id = Response.data.id;
                }

            } else {
                //update
                const Response = await updateCreateUser(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("user updated successfully");
                    formfields.id = Response.data.id;
                }
            }

        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFromFields((prevState) => ({
            ...prevState,
            [name]: value
        }));

    }
    return (
        <>

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Position
                </label>
                <div className="col-lg-6">
                    <input component="input"
                        placeholder="Display Order"
                        name="position"
                        className="form-control"

                        value={position} maxLength={50} onChange={handleChange} />

                </div>
                <div className="errorMsg">{errorFields.position}</div>
            </div>

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Name
                </label>
                <div className="col-lg-6">
                    <input component="input"
                        placeholder="Name"
                        name="name"
                        className="form-control"

                        value={name} maxLength={50} onChange={handleChange} />

                </div>
                <div className="errorMsg">{errorFields.name}</div>
            </div>

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Email
                </label>
                <div className="col-lg-6">
                    <input component="input"
                        placeholder="Email"
                        name="email"
                        className="form-control"

                        value={email} maxLength={50} onChange={handleChange} />

                </div>
                <div className="errorMsg">{errorFields.email}</div>
            </div>

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Password
                </label>
                <div className="col-lg-6">
                    <input component="input"
                        placeholder="Password"
                        name="password"
                        className="form-control"

                        value={password} maxLength={50} onChange={handleChange} />

                </div>
                <div className="errorMsg">{errorFields.password}</div>
            </div>
            <br />
            <div className="form-group">
                <button onClick={submitForm} className="btn btn-primary" type="button"
                >Save</button>
            </div>

        </>
    )
}

export default AddCreateUser